import { Component, Inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ENV_CONFIG } from 'src/app/core/injection.token';

@Component({
  selector: 'asset-inspection-modal',
  standalone: false,
  templateUrl: './asset-inspection-modal.component.html',
  styleUrl: './asset-inspection-modal.component.scss',
})
export class AssetInspectionModalComponent {
  androidLink: string;
  iosLink: string;

  constructor(
    private _activeModal: NgbActiveModal,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvConfigurationData
  ) {
    this.androidLink = this._envConfig.ANDROID_MOBILE_LINK || 'This is the Android App Link';
    this.iosLink = this._envConfig.IOS_MOBILE_LINK || 'This is the iOS App Link';
  }

  closeModal(): void {
    this._activeModal.close();
  }
}
